import { Landmark, Building2, Shield, Network, Database, Briefcase, Hospital, Plane } from "lucide-react";

const ITEMS = [
  { icon: Landmark, label: "Treasury Bureau" },
  { icon: Building2, label: "Northbank Capital" },
  { icon: Shield, label: "Defense Logistics Cmd." },
  { icon: Network, label: "Meridian Telecom" },
  { icon: Database, label: "AltStream Data Co." },
  { icon: Briefcase, label: "Halford & Stern" },
  { icon: Hospital, label: "St. Andrew Health Sys." },
  { icon: Plane, label: "Civil Aviation Auth." },
];

export default function TrustedBy() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="trusted-section" className="border-b border-neutral-200 bg-white py-10">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 mb-6 flex items-center gap-4">
        <span className="font-mono-tech text-xs tracking-[0.2em] uppercase text-neutral-500">
          [02] Selected clients & agencies
        </span>
        <span className="h-px flex-1 bg-neutral-200" />
      </div>
      <div className="overflow-hidden">
        <div className="flex gap-12 animate-marquee whitespace-nowrap w-max">
          {loop.map((it, i) => (
            <div
              key={i}
              data-testid={`trusted-item-${i}`}
              className="flex items-center gap-3 text-neutral-700"
            >
              <it.icon className="w-5 h-5" strokeWidth={1.5} />
              <span className="font-display text-xl tracking-tight">{it.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
